import { render, staticRenderFns } from "./gatherers.vue?vue&type=template&id=e827bf8c"
import script from "./gatherers.vue?vue&type=script&lang=js"
export * from "./gatherers.vue?vue&type=script&lang=js"
import style0 from "./gatherers.vue?vue&type=style&index=0&id=e827bf8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports